!function(window) {

$('#entry-slick').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 10000,
	infinite: false,
	draggable: true,
	dots: true,
	arrows: false,
	fade: true,
	cssEase: 'linear'
});

var colors = ['#99CCFF', '#FF9900', '#99CC66'];
$('#entry-slick').on('beforeChange', function(event, slick, currentSlide, nextSlide){
	$('.logo-content #accent_1').css('fill', colors[nextSlide]);
	$('.logo-content #accent_2').css('fill', colors[nextSlide]);
});

$(window).load(function () {
	
	$('.slick-content').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		initialSlide:0,
		centerMode: true,
		autoplay: false,
		autoplaySpeed: 4000,
		infinite: false,
		variableWidth: true,
		draggable: true,
		dots: false,
		arrows: true,
		prevArrow: $('.slick-arrow.prev'),
		nextArrow: $('.slick-arrow.next'),
		accessibility: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					adaptiveHeight: true
				}
			}
		]
	});
	
	$('.slickItems').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		initialSlide:0,
		centerMode: false,
		autoplay: false,
		autoplaySpeed: 4000,
		infinite: false,
		variableWidth: true,
		draggable: true,
		dots: false,
		arrows: true,
		prevArrow: $('.slick-arrow.prev'),
		nextArrow: $('.slick-arrow.next'),
		accessibility: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					adaptiveHeight: true
				}
			}
		]
	});
	
});


function triggerLightGallery(){
	let selector = $('.lightgallery');
	
	if(selector.length){
		$(selector).lightGallery({
			download: false,
			thumbnail:true,
			exThumbImage: 'data-src'
		});
		$('.open-gal').on('click', function(){
			$('.lightgallery a:first-child').trigger("click");
		});
	}
}
triggerLightGallery();

window.colors = colors;
window.triggerLightGallery = triggerLightGallery;
}(window);